import React from 'react';
import '../styles/Footer.css';

const Footer = (background) => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <a href="/">
              <img src="/images/contractwell.png" alt="ContractWell Logo" className="logo-image" />
            </a>
          </div>
          
          <div className="footer-links">
            <div className="legal-links">
              <a href="/pdfs/privacypolicy.pdf">Privacy Policy</a>
              <span className="separator">|</span>
              <a href="/pdfs/websiteterms.pdf">Website Terms</a>
              <span className="separator">|</span>
              <a href="/pdfs/disclaimer.pdf">Disclaimer</a>
            </div>
          </div>
          
          <div className="social-icons">
            <a href="https://www.instagram.com/contract.well/" className="social-icon" title="Visit our Instagram (contract.well)">
              <svg viewBox="0 0 24 24" width="14" height="14">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="currentColor" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" stroke="currentColor" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke="currentColor" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
